import { useTranslation } from "react-i18next";
import {phenotypeTypes} from "../../resources/json/jsons";
import i18n from "i18next";
import {Consts} from "../pages/consts";
import {buildInteractionParam} from "../pages/utils";

const DgiElement = ({ dgi, number }) => {
  const { t } = useTranslation();
  let phenoForSearch = dgi?.phenotype;

  if(phenoForSearch?.indexOf(Consts.POOR_521CC) > 0){
    phenoForSearch = Consts.POOR_FUNCTION;
  } else if(phenoForSearch?.indexOf(Consts.INTERMEDIATE_521TC) > 0){
    phenoForSearch = Consts.INTERMEDIATE_FUNCTION;
  }

  const pheno = phenotypeTypes[phenoForSearch]?.[i18n.language?.toUpperCase()];

  return (
    <div className="w3-container w3-left-align w3-border w3-round-large w3-padding-small w3-margin">
      <div className="w3-row">
        <label>
          {number + 1}
          {". "} <b>{dgi.gene}</b>
        </label>
      </div>
      <div className="w3-row">
        <label className="w3-margin-right">
          <b>{t("genotype")}</b>: {dgi.genotype}
        </label>
      </div>
      {dgi.genotypeRecommendation && (
        <div className="w3-row">
          <label className="w3-margin-right">
            {t("recommendation")}: { buildInteractionParam(dgi?.genotypeRecommendation, true) }
          </label>
        </div>
      )}
      <div className="w3-row">
        <label className="w3-margin-right">
          <b>{t("phenotype")}</b>: {pheno}
        </label>
      </div>
      {dgi.phenotypeRecommendation && (
        <div className="w3-row">
          <label className="w3-margin-right">
            {t("recommendation")}: { buildInteractionParam(dgi?.phenotypeRecommendation, true) }
          </label>
        </div>
      )}
      {dgi.completeRecommendation !== null && (
        <div className="w3-row">
          <label className="w3-margin-right">
            {t("recommendation")}: { buildInteractionParam(dgi?.completpeRecommendation, true) }
          </label>
        </div>
      )}
    </div>
  );
};

export default DgiElement;
